import { useTranslations } from 'next-intl';

interface SubmitButtonProps {
	onSubmit: () => void;
	isLoading: boolean;
	errorMsg?: string;
}

export const SubmitButton = ({ onSubmit, isLoading, errorMsg }:SubmitButtonProps) => {
	const t = useTranslations('General');

	return (
		<div className="survey-form__submit">
			<div className="survey-btn" data-disabled={isLoading} onClick={onSubmit}>
				<span className="survey-btn__text">{t('lbl_SabaSurveySubmit02')}</span>
				<span className="survey-btn__loading"></span>
			</div>
			{errorMsg &&
			<div className="survey-submit-error">
				<span className="survey-form__icon-error"></span>
				<span>{t(errorMsg)}</span>
			</div> 
			}
		</div>
	)
}